var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconPremium = function SvgS2IconPremium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12 16.174 1.026 6.486c-.216-.997 1.026-1.668 1.792-.968l3.46 3.167 2.75-5.632c.388-.795 1.558-.795 1.946 0l2.75 5.632 3.46-3.167c.766-.7 2.008-.03 1.792.968l-2.096 9.688a1.067 1.067 0 0 1-1.052.827H4.173c-.509 0-.948-.345-1.052-.827Z"
  })));
};
export default SvgS2IconPremium;